"use strict";

var _classCallCheck = require("C:/Users/tnola/Desktop/Code Projects/ThorNolan.github.io/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("C:/Users/tnola/Desktop/Code Projects/ThorNolan.github.io/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Split = void 0;

var SplitFactor_1 = require("./SplitFactor");

var SplitRate_1 = require("./SplitRate");

var Utils_1 = require("../../../../Utils");

var Split = /*#__PURE__*/function () {
  function Split() {
    _classCallCheck(this, Split);

    this.count = 1;
    this.factor = new SplitFactor_1.SplitFactor();
    this.rate = new SplitRate_1.SplitRate();
    this.sizeOffset = true;
  }

  _createClass(Split, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.count !== undefined) {
        this.count = data.count;
      }

      this.factor.load(data.factor);
      this.rate.load(data.rate);

      if (data.particles !== undefined) {
        this.particles = Utils_1.deepExtend({}, data.particles);
      }

      if (data.sizeOffset !== undefined) {
        this.sizeOffset = data.sizeOffset;
      }
    }
  }]);

  return Split;
}();

exports.Split = Split;